const players = new Map();

export function registerChapterPlayer(id, src, player) {
  const key = `${id}:${src}`;
  players.set(key, player);
  return () => { if (players.get(key) === player) players.delete(key); };
}

export function chapterPlayer(id, src) {
  return players.get(`${id}:${src}`)?.current || null;
}
